<template>
    <v-container v-if="getLanguageList" class="pa-2" fluid grid-list-sm >   
        <v-layout row wrap>
            <v-flex xs8>
                
            </v-flex>
            <v-flex xs4>
                <CountDown />
            </v-flex>
        </v-layout>       
    <div v-if="needInit">{{initData()}}</div>  
   
        <v-layout row wrap>
            <v-flex xs6> <v-card class="shadow-none" outlined >  
                <language-list v-bind:ltype="1"></language-list>
                <q-type11 v-bind:ltype="1"></q-type11>
            </v-card>  </v-flex>
            <v-flex xs6> <v-card class="shadow-none" outlined >   
                <language-list v-bind:ltype="2"></language-list>
                <q-type11 v-bind:ltype="2"></q-type11>
            </v-card>  </v-flex>
            <v-flex xs12>
                <v-card class="shadow-none" outlined >
                    <p></p>
                    <p v-if="getRefresh1 || getRefresh2">Preparing...</p>
                    <p v-if="getPreparedforSave && runSaving">{{saveData()}}</p>                    
                    <v-layout align-end justify-space-between row fill-height>
                            <v-flex xs2>
                            </v-flex>
                            <v-flex xs1>
                                <v-text-field
                                    v-model="max_score"
                                    label="Score:"
                                    ></v-text-field>                              
                            </v-flex>
                            <v-flex xs4>
                                <v-card class="shadow-none" outlined>
                            <v-btn v-if="showSaveButton && (getCountdownStatus.count > 0 || getCountdownStatus.count == -100)" @click="saveAndClose">Save and close</v-btn>
                                    <v-btn @click="closeForm">Close without saving</v-btn>                    
                                </v-card>
                            </v-flex>
                    </v-layout>
                    <p></p>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import QType_11 from '../QType_11'
import LanguageList from '../LanguageList.vue'
import {mapGetters} from 'vuex'
import CountDown from '../../../components/misc/CountDown.vue'
import axios from '../../../axios-auth.js'

export default {
    data() {
        return {    
             runSaving: false,
             closeAfterSaving: false,
             content11: null,
             max_score: 10,
             task_type_id: 2,
             needInit : true,
             ID: 0,
             order: 0,
             lessonID: 0,
             showSaveButton: true
        }
    },
    computed: 
        mapGetters([
                        'getRefresh1',
                        'getRefresh2',
                        'getAllContent11',
                        'getRulesGlobals',
                        'getLanguagePrimary',
                        'getLanguageSecondary',
                        'getPreparedforSave',
                        'getLanguageList',
                        'getAxiosConfig',
                        'getCountdownStatus'
                    ])
    ,
    components: {
        QType11 : QType_11,
        LanguageList,
        CountDown
    },
    beforeDestroy() {
        const data = { task_id: this.ID}
        axios.post('/unlock', data, this.getAxiosConfig)
        .then(() => {                
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)            
        })
    },
    methods : {
        prepareDataforSave() {
            this.$store.commit('setFeedback', null)
            //// xxxxx check data

            this.runSaving = true
            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)

            this.$store.commit('setPreparedforSave',false)
            // send notification for save to store
            this.$store.commit('setRefresh1',true)
            this.$store.commit('setRefresh2',true)
        },
        saveData() {
            this.runSaving = false
            // prepare data for json
            const data = this.getAllContent11 
            const _globals = JSON.stringify ({
                globals : this.getRulesGlobals 
            })

            this.content11 = {
                lesson_id: this.lessonID,
                task_id : this.ID,
                task_order : this.order,
                task_type_id : this.task_type_id,
                globals: _globals,
                max_score : this.max_score,
                content_list: []
            }
            
            for(var key in data) {
                this.content11.content_list.push( {
                    lang_id : key.replace('l',''),
                    content : JSON.stringify (data[key])
                })
            }

            // axios
            axios.post('/create-edit-task-all-lang', this.content11, this.getAxiosConfig)
            .then(() => {    
                if (this.closeAfterSaving) this.closeForm()
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        
        },

        saveAndClose() {
            this.closeAfterSaving = true
            this.prepareDataforSave()            
        },
        closeForm() {
            this.$router.push({name:'lesson_admin_content', params: {id: this.lessonID}})
        },
        initData() {
            this.needInit = false
            this.$store.commit('setCountdownStatus', { id: this.$route.params.id, count: 1800, max: 1800})

            this.$store.commit('setFeedback', null)
            this.$store.commit('setCollapses')    

            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)


            // set rules list  must be called before setcontent because of refresh data
                axios.get('/get-html-rules', this.$store.getters.getAxiosConfig )
                .then(res => {
                    
                   this.$store.commit('setHTMLSystemRules', res.data)

                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })

            this.ID = this.$route.params.id
            this.lessonID = this.$route.params.lesson_id

            if ( this.ID == '0') {
                this.$store.commit('prepare11')
                this.task_type_id = localStorage.getItem('qtype')
                this.$store.dispatch('createEmptyAdminBreadCrumbs',this.lessonID)
            } else {
            // load existing data
                axios.get('/get-task-in-all-lang/' + this.ID, this.$store.getters.getAxiosConfig )
                .then(res => {
                    this.$store.dispatch('setAdminBreadCrumbs',res.data)
                    if (res.data.islocked) {
                        this.showSaveButton = false
                        this.$store.commit('setFeedback', 'The content is locked by another user, you can only read or wait 30 minutes.')    
                    }

                    this.max_score = res.data.max_score
                    this.task_type_id = res.data.task_type
                    this.order = res.data.task_order

                    const data = {
                        globals : JSON.parse(res.data.globals),
                        content_list : res.data.list
                    }

                    this.$store.dispatch('setFullContent11', data)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
            }
        
        }
    },
    mounted() {
        this.needInit = true
        this.$store.commit('setDeleteElement',-1)
    }      
     
}
</script>


